export default [
	{//系统用户
		path: 'users',
		name: 'm_sysuser',
		props: route => route.params,
		component: () => import('@/pages/system/sysuser_list')
	}, {//部门管理
		path: 'department',
		name: 'm_department',
		props: route => route.params,
		component: () => import('@/pages/system/department_list')
	}, {//账号信息
		path: 'factory',
		name: 'm_factory',
		props: route => route.params,
		component: () => import('@/pages/system/factory')
	}, {//销售客户
		path: 'sale_customer',
		name: 'm_sale_customer',
		props: route => route.params,
		component: () => import('@/pages/system/sale_customer_list')
	}, {//回收质检仓
		path: 'quality_warehouse',
		name: 'm_quality_warehouse',
		props: route => route.params,
		component: () => import('@/pages/system/quality_warehouse_list')
	}
];